import isNil from 'lodash-es/isNil'
import { Nullable } from '@/types/nullable'

const isNotNil = <T>(item?: Nullable<T>): item is T => {
  return !isNil(item)
}

export default isNotNil
